var map = {
  "./en/location.json": [
    "616305",
    [
      62314
    ]
  ],
  "./sv/location.json": [
    "522387",
    [
      8080
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(function() { return __webpack_require__.t(id, 3 | 16); });
}

__rspack_async_context.keys = function() { return Object.keys(map); };
__rspack_async_context.id = 269997;
module.exports = __rspack_async_context;
